module.exports = __webpack_public_path__ + "static/media/LogoVNW-Transparente.78241880.png";